import { CLEAR_SESSION } from '~/redux/actions/types'

export const clearSession = () => {
  return {
    type: CLEAR_SESSION
  }
}
